<template>
    <div class="grid">
        <div class="grid-title">
        <h4>{{ $t("EMAIL_CONFIGURATION") }}</h4>
         <v-btn color="primary" class="pl-10 pr-10" @click="updateEmail">{{ $t("SAVE") }}</v-btn>
        </div>
        <div class="grid-body p-3 border-top-unset">
            <div>
                <v-row>
                    <v-col>
                        <label>{{$t('EMAIL_TYPE')}}</label>
                        <v-radio-group v-model="typeEmail" name="radio-sub-component-type" row>
                            <v-radio value="EZCLOUD">
                                <template v-slot:label>
                                <div>ezCloud email</div>
                                </template>
                            </v-radio>
                                <v-radio value="HOTEL">
                                <template v-slot:label>
                                <div>{{$t('HOTEL_EMAIL')}}</div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-form>
                    <v-row v-if="typeEmail === 'HOTEL'">
                        <v-col md="6">
                            <label :class="validateEmail(email.from) === false && errEmail === true ? 'text-danger' : ''">{{$t('EMAIL_SEND')}}</label>
                            <v-text-field dense outlined  v-model="email.from" required :class="validateEmail(email.from) === false ? 'required-valid-email' : ''"></v-text-field> 
                        </v-col>
                        <v-col md="6">
                            <label :class="(email.fromName === null || email.fromName === '') && errEmail === true ? 'text-danger' : ''">{{$t('EMAIL_NAME_SEND')}}</label>
                            <v-text-field dense outlined  v-model="email.fromName" required :class="email.fromName === null || email.fromName === '' ? 'required-valid-email' : ''"></v-text-field>
                        </v-col>
                        <v-col md="6">
                            <label :class="(email.host === null || email.host === '') && errEmail === true ? 'text-danger' : ''">{{$t('SERVER_MAIL_ADDRESS')}}</label>
                            <v-text-field dense outlined  v-model="email.host" required :class="email.host === null || email.host === '' ? 'required-valid-email' : ''"></v-text-field>
                        </v-col>
                        <v-col md="6">
                            <label>{{$t('ENCRYPTION_TYPE')}}</label>
                            <v-radio-group v-model="email.encryption" name="radio-sub" row>
                                <v-radio :value="0">
                                    <template v-slot:label>
                                    <div>none</div>
                                    </template>
                                </v-radio>
                                <v-radio value="SSL">
                                    <template v-slot:label>
                                    <div>SSL</div>
                                    </template>
                                </v-radio>
                                 <v-radio value="TLS">
                                    <template v-slot:label>
                                    <div>TLS</div>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col md="6">
                            <label :class="isNumber(email.port) === false && errEmail === true ? 'text-danger' : ''">{{$t('CONNECTOR')}}</label>
                             <v-text-field dense outlined  type="number" v-model="email.port" required :class="isNumber(email.port) === false ? 'required-valid-email' : ''"></v-text-field>
                        </v-col>
                        <v-col md="6">
                            <label>{{$t('AUTHENTICATON_CONNECTION')}}</label>
                            <v-radio-group v-model="email.authentication" name="radio-sub-component" row>
                                <v-radio :value="true">
                                    <template v-slot:label>
                                    <div>{{$t('YES')}}</div>
                                    </template>
                                </v-radio>
                                 <v-radio :value="false">
                                    <template v-slot:label>
                                    <div>{{$t('NO')}}</div>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col md="6">
                            <label :class="(email.username === null || email.username === '') && errEmail === true ? 'text-danger' : ''">{{$t('_EDIT_USER.USERNAME')}}</label>
                            <v-text-field dense outlined  v-model="email.username" required :class="email.username === null || email.username === '' ? 'required-valid-email' : ''"></v-text-field>
                        </v-col>
                        <v-col md="6">
                            <label :class="(email.password === null || email.password  === '') && errEmail === true ? 'text-danger' : ''">{{$t('_EDIT_USER.PASSWORD')}}</label>
                            <v-text-field dense outlined  type="password" v-model="email.password" required :class="email.password === null || email.password === '' ? 'required-valid-email' : ''"></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
            <div class="border-top mt-3" v-if="isConfigEmail === true">
                <p class="m-0 pt-3">{{$t('TEST_EMAIL_SENT')}}</p>
                <v-row class="email-test">
                    <v-col md="4">
                        <label :class="validateEmail(email_test) === false && error_email_test === true ? 'text-danger' : ''">{{$t('EMAIL_SEND')}}</label>
                        <v-text-field dense outlined  v-model="email_test" required :class="validateEmail(email_test) === false ? 'required-valid-email-test' : ''"></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <label>&nbsp;</label>
                        <v-btn color="primary" height="40" class="w-100" @click="testEmail()" :disabled="loading_sent_email === true">{{$t('SENT_EMAIL_TEST')}}</v-btn>
                    </v-col>
                    <v-col></v-col>
                </v-row>
                <p class="d-note m-0" v-if="txt_faild"><i class="icon-Error fs-18 text-danger"></i> {{$t('ERROR_MAIL')}} <br> {{txt_faild}}</p>
                <p class="d-note m-0" v-if="txt_success"><i class="icon-Check-Mark fs-18 text-success"></i> {{$t('SUCCESS_MAIL')}}</p>
            </div>
            <hr/>
            <div class="mr-3 pb-3 d-flex align-center" style="max-width: 350px">
                <label class="text-nowrap mr-2">{{
                $t("CHANNEL_APPLY")
                }}</label>
                <v-autocomplete dense outlined item-text="text" item-value="value" :items="listOtaConnectGlobal"
                v-model="selectedOTAGlobal" chips multiple style="width: 270px;" disabled>
                <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-bind="item.attrs" :input-value="item.selected" >
                    <span>{{ item.text }}</span>
                    </v-chip>
                </template>
                </v-autocomplete>
            </div>
        </div>
    </div>
</template>
<script>
import { configBeService } from "@/_services/configbe.service.js";
import Input from "@/components/Utils/Input.vue";
export default {
  components: {
       "input-text": Input
  },
  data() {
    return {
         email: {
				host: 'smtp.example.com',
				port: '123',
				username: null,
				password: null,
				encryption: 'SSL',
				authentication: true,
				from: null,
				fromName: null,
        },
        typeEmail: 'EZCLOUD',
        errEmail: false,
        contract: null,
        tab: 0,
        loading: true,
        error_email_test: false,
        email_test: null,
        isConfigEmail: true,
        txt_faild: null,
        txt_success: null,
        loading_sent_email: false,
    };
  },
  watch: {
      typeEmail() {
			if (this.typeEmail === 'HOTEL') {
				this.callApiDetailEmail();
			} else {
                this.isConfigEmail = false;
            }
		},
  },
  created() {
    this.getEmailType();
  },
  methods: {
      getEmailType() {
        configBeService.getEmailType().then(
            response => {
                if (response.responseCode === 0) {
                    this.typeEmail = response.data;
                    if (this.typeEmail === 'EZCLOUD') {
                        this.isConfigEmail = false;
                    }
                }
            },
            error => {
                if (error.status === 403) {
                    this.showAlertLogout();
                }
            },
        );
    },
    updateEmailType() {
       configBeService.updateEmailType(this.typeEmail).then(
            response => {
                if (response.responseCode === 0) {
                    if (this.typeEmail === 'HOTEL') {
                        const declaration = document.getElementsByClassName('required-valid-email') || [];
                        if (declaration.length === 0) {
                            if (this.email.encryption === 0) {
                                this.email.encryption = null;
                            }
                            return configBeService.updateEmail(this.email).then(
                                response1 => {
                                    if (response1.responseCode === 0) {
                                        this.errEmail = false;
                                        this.$bvToast.toast(this.$t('SAVE_SUCCESS'), {
                                            title: this.$t('NOTIFICATION'),
                                            variant: 'primary',
                                            solid: true,
                                            autoHideDelay: 1500,
                                        });
                                    } else {
                                         this.$bvToast.toast(this.$t(response1.data), {
                                            title: this.$t('NOTIFICATION'),
                                            variant: 'warning',
                                            solid: true,
                                            autoHideDelay: 1500,
                                        });
                                    }
                                    this.callApiDetailEmail();
                                },
                                error => {
                                    if (error.status === 403) {
                                        this.showAlertLogout();
                                    }
                                },
                            );
                        } else {
                            this.errEmail = true;
                            document.getElementsByClassName('required-valid-email')[0].focus();
                        }
                    } else {
                        this.$bvToast.toast(this.$t('SAVE_SUCCESS'), {
                            title: this.$t('NOTIFICATION'),
                            variant: 'primary',
                            solid: true,
                            autoHideDelay: 1500,
                        });
                    }
                }
            },
            error => {
                if (error.status === 403) {
                    this.showAlertLogout();
                }
            },
        );
    },
    callApiDetailEmail() {
        configBeService.detailEmail().then(
            response => {
                if (response.responseCode === 0) {
                    this.email = Object.assign({}, response.data);
                    if (this.email.encryption === null) {
                        this.email.encryption = 0;
                    }
                    this.isConfigEmail = true;
                } else {
                    this.isConfigEmail = false;
                }
            },
            error => {
                if (error.status === 403) {
                    this.showAlertLogout();
                }
            },
        );
    },
    updateEmail() {
        this.updateEmailType();

    },
    validateEmail(email) {
        if (email !== null && email !== '') {
            const regex = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}$/;
            if (email.match(regex)) {
                return true;
            }
            return false;
        }
        return false;
    },
    isNumber(value) {
        const valueProcess = value || '';
        if (valueProcess != null && valueProcess != '') {
            const regex = /^[0-9]*$/;
            if (valueProcess.toString().match(regex)) {
                return true;
            }
            return false;
        }
        return false;
    },
    testEmail() {
         this.txt_faild = null;
          this.txt_success = null;
        const declaration = document.getElementsByClassName('required-valid-email-test') || [];
        if (declaration.length === 0) {
            this.loading_sent_email = true;
            const body = {
                email: this.email_test,
            };
            configBeService.apiTestEmail(body).then(
                response1 => {
                    if (response1.responseCode === 0) {
                        this.error_email_test = false;
                         this.txt_success = response1.data;
                    } else {
                        this.error_email_test = false;
                        this.txt_faild = response1.data;
                    }
                    this.loading_sent_email = false;
                },
                error => {
                    this.loading_sent_email = false;
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        } else {
            this.error_email_test = true;
            document.getElementsByClassName('required-valid-email-test')[0].focus();
        }
    },
  }
};
</script>

<style>
</style>